import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { CommandesService } from 'src/app/services/commandes/commandes.service';

@Component({
  selector: 'app-add-box',
  templateUrl: './add-box.component.html',
  styleUrls: ['./add-box.component.css']
})
export class AddBoxComponent implements OnInit {

  isSaved: boolean = true

  @Output() result = new EventEmitter<any>();
  @Input() box: any;


  constructor(private activeModal: NgbActiveModal,
    private translate: TranslateService,
    private cmdService: CommandesService,
    private serviceClient: ClientsService,
    private service: SettingsService,) {
  }

  ngOnInit(): void {
    // console.log("this.box")
    // console.log(this.box)
    // if (this.box?.provider) {
    //   this.provider = this.box?.provider
    // }
  }

  // ngAfterViewInit() {
  //   if (this.provider)
  //     this.input.nativeElement.value = this.provider?.providerCode + ' - '
  //       + this.provider?.providerName
  // }

  saveBox() {
    var isValidate = this.checkField()
    if (!isValidate) {
      this.isSaved = isValidate
      this.translate.get('data.please_fill_in_the_required_fields')
        .subscribe(async (text: string) => {
          alert(text)
        });
    } else {
      this.box.volume = this.cmdService.formatNumber(
        this.box.t_wdth * this.box.t_dpth * this.box.t_hght, 3)
      this.service.saveBoxProduct(this.box)
        .then((res: any) => {
          if (res) {
           // console.log("resssssssss : ")
           // console.log(res)
            if (res?.response) {
              this.result.emit(res?.data);
              this.activeModal.dismiss();
            } else{
              alert(res.msg)
            }
          }
        });
    }
  }

  checkField() {
    if (this.box.ref != null && this.box.ref != "" &&
      this.box.t_seak != null && this.box.t_seak != "" &&
      this.box.t_hght != null && this.box.t_hght.toString() != "" &&
      this.box.t_wdth != null && this.box.t_wdth.toString() != "" &&
      this.box.t_dpth != null && this.box.t_dpth.toString() != "" &&
      this.box.ucs != null && this.box.ucs.toString() != "" //&&
      /*this.box.provider != null && this.box.provider != ""*/)
      return true
    else
      return false
  }

  closeModal() {
    this.result.emit(null);
    this.activeModal.dismiss();
  }

}
